module.exports = __webpack_public_path__ + "media/images/icons/ic-chat-32975943f42f233900eaa91407e8b744.svg";